import { ConfigurationSettingsDto } from '../../core/dto/configurationsettings/configurationsettingsdto';

export interface ConfigurationSettings
{
    getProperty(key: string): string;
    getPropertyBasedOnLanguage(key: string): string;
    getConfigurationSettings(key: string): ConfigurationSettingsDto;
    updateLanguage(language: string): void;
    setConfigurationSettings(settingsData: any): void;
}

export class ConfigurationSettingsImpl implements ConfigurationSettings
{
    private configurationSettingsMap: any;
    private language: string;

    updateLanguage(language: string): void 
    {
        this.language = language.toLocaleUpperCase();
    }

    setConfigurationSettings(settingsData: any): void
    {
        this.configurationSettingsMap = {};

        // tslint:disable-next-line: forin
        for (let key in settingsData) 
        {
            this.configurationSettingsMap[key] = new ConfigurationSettingsDto().fromJSON(settingsData[key]);
        }
    }

    getProperty(key: string): string 
    {
        let configurationDto = this.configurationSettingsMap[key];

        return configurationDto !== undefined ? configurationDto.getAttribute() : "";
    }    

    getConfigurationSettings(key: string): ConfigurationSettingsDto 
    {
        let configurationDto = this.configurationSettingsMap[key];

        return configurationDto !== undefined ? configurationDto : "";
    }

    getPropertyBasedOnLanguage(key: string): string 
    {
        if(this.configurationSettingsMap !== undefined)
        {
            let configurationDto = this.configurationSettingsMap[key + "_" + this.language];
            return configurationDto !== undefined ? configurationDto.getAttribute() : "";
        }
        else
        {
            return "";
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/configurationsettings/configurationsettings.ts